$(document).on("click","card-variant-selects input",function() {
  var input = $(this).parents('.card').find('.product-form__input input:checked');
  var json_data = JSON.parse($(this).parents('.card').find('[data-selected-variant]').text())
  var values = [];
  
  for (let i = 0; i < input.length; i++) {
    var val = $($(this).parents('.card').find('.product-form__input input:checked')[i]).val()
    values.push(val)
  }

  var compare = false;
  var selected = '';

  var value = ''
  for (let j = 0; j < values.length; j++) {
    if(j == 0){
      value = values[j]
    }else{
      value = value+" / "+values[j]
    }
  }
  for (let i = 0; i < json_data.length; i++) {
    if(value == json_data[i].title){
        selected = json_data[i];
    }
  }

  var colors = $(this).parents('.card').find('[name="Color"]')
  for (let i = 0; i < colors.length; i++) {
    var compare = true;
    for (let j = 0; j < json_data.length; j++) {
     $(colors[i]).removeAttr('disabled');
      if(json_data[j].option2 == $(colors[i]).val() && json_data[j].option1 ==  values[0]){
        compare = false;
       if(json_data[j].available){
         $(colors[i]).next().removeAttr('disabled');
       }else{
         $(colors[i]).next().attr('disabled', true);
         break;
       }
     }
    }
    if(compare){
       $(colors[i]).next().attr('disabled', true);
     }
  }
  

  if(selected.available){
    
    $(this).parents('.card').find('.product-variant-id').val(selected.id);
  
    var imgElement = input.parents('.card-wrapper').find('.card__media img')[0];
    imgElement.src = selected.featured_image.src;
    imgElement.srcset = selected.featured_image.src || '';
    
    $(this).parents('.card').find('form .quick-add__submit').removeAttr('disabled')
    $($(this).parents('.card').find('form .quick-add__submit > span')[0]).text('Add to cart')
  }else{
    $(this).parents('.card').find('form .quick-add__submit').attr('disabled','true');
    $($(this).parents('.card').find('form .quick-add__submit > span')[0]).text('Sold out')
  }
});